import React, {useContext} from "react";
import display from "../css/display.css";
import star_icon from "./Assets/star_icon.png";
import star_dull_icon from "./Assets/star_dull_icon.png";
import {ShopContext} from "./Providers/ShopContext";

const ProductDisplay = (props) => {
  const {product} = props;
  const {addToCart} = useContext(ShopContext);
  return (
    <div style={display} className="display">
      <div className="display-left">
        <div className="display-img-list">
          <img src={product.image} alt="" />
          <img src={product.image} alt="" />
          <img src={product.image} alt="" />
          <img src={product.image} alt="" />
        </div>
        <div className="display-img">
          <img className="display-main-img" src={product.image} alt="" />
        </div>
      </div>
      <div className="display-right">
        <h1>{product.name}</h1>
        <div className="display-star">
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_dull_icon} alt="" />
          <p>(122)</p>
        </div>
        <div className="didsplay-right-prices">
          <div className="display-right-old">${product.old_price}</div>
          <div className="display-right-new"> ${product.new_price} </div>
        </div>
        <div className="display-description">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </div>
        <div className="display-size">
          <h1>SELECT SIZE</h1>
          <div className="display-sizes">
            <div>S</div>
            <div>M</div>
            <div>L</div>
            <div>XL</div>
            <div>XXL</div>
          </div>
        </div>
        <button
          onClick={() => {
            addToCart(product.id);
          }}
        >
          ADD TO CART
        </button>
        {/* <div className="display-rigt-category">
          <span>Category:</span>Women, T-Shirt, Crop Top
        </div>
        <div className="display-rigt-category">
          <span>Tags:</span>Modern, Latest
        </div> */}
      </div>
    </div>
  );
};

export default ProductDisplay;
